<template>
  <div class="contracting-party">
    <div class="party-data-box box" v-for="(item,index) in partyData" :key="index" @click="handleActive(index)" :class="{'active': activeIndex == index}">
      <div class="top">
        <div class="top-left">{{ item.name }}</div>
        <div class="top-right">
          <i @click.stop="edit(item)" class="el-icon-edit-outline"></i>
          <i @click.stop="del(item)" class="el-icon-delete"></i>
        </div>
      </div>
      <div class="content">
        <div class="content-item">
          <div class="label">身份证号</div>
          <div class="value">{{item.card_id}}</div>
        </div>
        <div class="content-item">
          <div class="label">电话号码</div>
          <div class="value">{{item.phone}}</div>
        </div>
        <div class="content-item">
          <div class="label">详细地址</div>
          <div class="value">
            <template v-if="item.country_type == 1">
              {{ item.province }}{{ item.city }}{{ item.area }}{{ item.address }}
            </template>
            <template v-else>
              {{ countryName(item) }}{{ item.address }}
            </template>
          </div>
        </div>
      </div>
      <img v-if="activeIndex == index" class="active-img" src="@/assets/image/Contract/sellerInformationMobile/active.png" alt="">


    </div>
<!--    <div class="add box" @click="edit()">
      <div>
        <i class="el-icon-plus"></i>
        <div class="text">添加签约人</div>
      </div>
    </div>-->
    <!-- 删除签约人弹窗 -->
    <myDialog
      :title="'是否删除签约人信息？'"
      :btn-text="'确认'"
      btn
      :show="delPartyShow"
      :close-fun="() => {
        delPartyShow = false
      }"
    >
      <div slot="btn" class="confirmReceip-btnGroup">
        <div @click="delPartyShow = false">取消</div>
        <div @click="mydialogBtnClick">确认</div>
      </div>
    </myDialog>
  </div>
</template>

<script>
import myDialog from "@/components/myDialog";
import { addressArea } from '../newMap'
import { signatoryDel } from "../../../request/API";
let codes = require('../../../assets/json/coutryCode.json')
export default {
  name: 'ContractingParty',
  components: {
    myDialog,
  },
  props: {
    partyData: {
      type: Array,
      default() {
        return []
      }
    },
    countryList: {
      type: Array,
      default() {
        return []
      }
    }
  },
  data() {
    return {
      btnLoading: false,
      activeIndex: 0,
      delPartyShow: false,
      editPartyShow: false,
      form: {
        name: '',
        card_id: '',
        country_type: 1,
        country_code: '',
        province: '',
        city: '',
        area: '',
        address: '',
        phone: '',
      },
      ChinaAddressArea: addressArea,
      provinceList: [],
      cityList: [],
      districtList: [],
      rules: {
        name: [{ required: true, message: "请输入姓名", trigger: "blur" }],
        card_id: [
          { required: true, message: "请输入身份证号", trigger: "blur" },
          { validator: this.validate, trigger: ['change', 'blur'] }
        ],
        phone: [{ required: true, message: "请输入手机号", trigger: "blur" }],
        country_type: [{ required: true, message: "请选择联系地址", trigger: "change" }],
        address: [
          { required: true, message: "请完善联系地址", trigger: "blur" },
          {
            min: 5,
            max: 100,
            message: "请输入5~100个字的准确现住地址",
            trigger: "blur",
          },
        ],
      },
      // 删除签约人id
      delSignId: '',
      delActive: false,
    }
  },
  methods: {
    // 国家码转换
    countryName(data) {
      return this.countryList.find(item => item.tel == data.country_code)?.name || ''
    },
    /**
     * @description: 身份证格式验证
     * @param {*} rule
     * @param {*} value
     * @param {*} callback
     * @return {*}
     */
    validate(rule, value, callback) {
      let reg = /^[1-9]\d{5}(18|19|20|(3\d))\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/;
      if (this.form.id || reg.test(value)) {
        callback()
      } else {
        callback(new Error('身份证号码格式错误!'));
      }
    },
    /**
     * @description: 关闭弹窗获取列表
     * @return {*}
     */
    handleClose() {
      this.editPartyShow = false
      this.$emit('refreshData')
      if(this.delActive){
        this.delActive = false
        this.handleActive(0)
      }
    },
    /**
     * @description: 选中
     * @param {*} index
     * @return {*}
     */
    handleActive(index) {
      this.activeIndex = index
      this.$emit('handleActive',{id: this.partyData[this.activeIndex].id, index})
    },
    /**
     * @description: 重置
     * @return {*}
     */
    resetInfo() {
      // this.$refs.form.resetFields()
      this.form = {
        name: '',
        card_id: '',
        country_type: 1,
        country_code: '',
        province: '',
        city: '',
        area: '',
        address: '',
        phone: '',
      }
      this.$nextTick(() => {
        this.$refs.form.clearValidate()
      })
    },
    /**
     * @description: 删除签约人弹窗
     * @return {*}
     */
    del(item,flag) {
      this.delPartyShow = true
      this.delSignId = item.id
      this.delActive = flag
    },
    /**
     * @description: 添加/编辑签约人
     * @return {*}
     */
    edit(item) {
      // if (item != '') {
      //   signatoryDetails({
      //     client: 'mobile',
      //     sign_id: item.id
      //   }).then(res => {
      //     this.form = res.data
      //     this.form.id = item.id
      //   })
      // }
      this.$emit('open',item)
      // this.editPartyShow = true
    },
    /**
     * @description: 删除签约人
     * @return {*}
     */
    mydialogBtnClick() {
      signatoryDel({
        client: 'mobile',
        sign_id: this.delSignId
      }).then(res => {
        this.$message({
          message: '删除成功',
          center: true,
          offset: 200,
          customClass: 'sell-contract-msg'
        })
        this.handleClose()
      }).catch(err => {
        this.$message({
          message: '删除失败',
          center: true,
          offset: 200,
          customClass: 'sell-contract-msg'
        })
      })
      this.delPartyShow = false
    },
  },
}
</script>

<style lang="less" scoped>
.contracting-party{
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  margin: 12px 0 0 ;
  .box{
    width: 100%;
    background: #FFFFFF;
    border-radius: 4px;
    border: 1px solid #DEE3EC;
    box-sizing: border-box;
    padding: 11px 19px 12px 20px;
  }
  .add{
    height: 163px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #DEE3EC;
    text-align: center;
    .el-icon-plus{
      font-size: 80px;
    }
    >div{
      font-size: 12px;
      font-family: PingFang SC-Regular, PingFang SC;
      font-weight: 400;
      .text{
        margin-top: 10px;
      }
    }
  }
  .party-data-box{
    margin-bottom: 12px;
    cursor: pointer;
    .top{
      display: flex;
      justify-content: space-between;
      align-items: center;
      border-bottom: 1px solid #DEE3EC;
      padding-bottom: 12px;
      &-left{
        font-size: 16px;
        font-family: PingFang SC-Medium, PingFang SC;
        font-weight: 500;
        color: #333333;
      }
      &-right{
        color: #333333;
        i{
          margin-left: 15px;
          font-size: 20px;
          cursor: pointer;
          &:hover{
            color: #F0EDE8;
          }
        }
      }
    }
    .content{
      padding-top: 2px;
      &-item{
        display: flex;
        align-items: flex-start;
        justify-content: flex-start;
        margin-top: 8px;
        font-family: PingFang SC-Regular, PingFang SC;
        font-weight: 400;
        color: #333333;
        .label{
          min-width: 56px;
          margin-right: 14px;
          font-size: 14px;
          font-family: PingFang SC-Regular, PingFang SC;
          font-weight: 400;
          color: #999999;
        }
        .value{
          font-size: 14px;
          font-family: PingFang SC-Regular, PingFang SC;
          font-weight: 400;
          color: #333333;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          overflow: hidden;
        }
      }
    }
  }
  .active{
    border: 1px solid var(--primary);
    position: relative;
    background: var(--primary-soft);
    .top{
      .top-left{
        color: var(--primary);
      }
    }
    .active-img{
      position: absolute;
      bottom: 0;
      right: 0;
      width: 38px;
      height: 32px;
    }
  }
}
.confirmReceip-btnGroup {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 30px;

  div {
    font-size: 16px;
    font-family: PingFang SC-Medium, PingFang SC;
    font-weight: 500;
    color: #000000;
    width: 138px;
    height: 38px;
    border-radius: 3px;
    opacity: 1;
    border: 1.5px solid var(--bg-dark);
    color: var(--text-main);
    cursor: pointer;
    user-select: none;
    text-align: center;
    line-height: 38px;
  }

  div:last-of-type {
    background: var(--primary);
    border: 1.5px solid var(--primary);
    color: #FFF;
    margin: 0 0 0 15px;
  }
}
/deep/ .tipDialog #tipDialog .title{
  font-size: 18px;
  color: #333333;
}
/deep/ .tipDialog #tipDialog .text{
  margin: 39px 0 0;
}
.edit-party-dia{
  .w-298{
    width: 298px;
  }
  .w-95{
    width: 95px;
  }
  .select{
    margin: 0 6px 0;
  }
}



</style>
